<template lang="pug">
  .AppIndex
    img(class="notFound" src="../assets/appIndex/404.png")
    div Sorry!请前往pc端查看
    div 扫微信二维码了解更多!
    img(class="qrCode" src="../assets/appIndex/qrCode.jpg")
</template>

<script>
export default {
  name: 'AppIndex',
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.AppIndex {
  height: 100%;
  background: radial-gradient(closest-corner circle at 50% 50%, rgba(255, 255, 255, 0.2), rgba(0, 0, 0, 0));
  background: url("../assets/app_bg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;

  .notFound {
    width: 300px;
    margin-bottom: 10px;
  }

  .qrCode {
    margin-top: 15px;
    width: 156px;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/index/AppIndex/AppIndex.vue